import React, { useEffect } from "react";

const BlogLayout = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={styles.page}>
      {/* ===== Banner Section ===== */}
      <div style={styles.bannerSection}>
        <div style={styles.bannerOverlay}></div>
        <div style={styles.bannerContent}>
          <h1 style={styles.bannerTitle} className="slide-in">
            AI in Digital Marketing
          </h1>
          {/* <p style={styles.bannerText} className="slide-in">
            Transforming Customer Engagement and Marketing Strategies with AI
          </p> */}
        </div>
      </div>

      {/* ===== Blog Container ===== */}
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>
            How AI is Revolutionizing Digital Marketing in the 21st Century
          </h1>

          {/* Author & Meta */}
          <div style={styles.meta}>
            <img
              src="/images/author.jpg"
              alt="Author"
              style={styles.authorImage}
            />
            <div>
              <p style={styles.author}>By Sarah Williams</p>
              <p style={styles.details}>
                <i className="far fa-calendar-alt" style={styles.iconInline}></i>{" "}
                23 Aug 2025 &nbsp; | &nbsp;
                <i className="far fa-clock" style={styles.iconInline}></i> 9 min
                read &nbsp; | &nbsp;
                <i className="far fa-eye" style={styles.iconInline}></i> 1,850
                Views
              </p>
            </div>
          </div>

          {/* Blog Intro */}
          <p style={styles.text}>
            <i className="fas fa-robot" style={styles.iconInline}></i>
            Digital marketing has undergone a massive transformation in recent
            years, with Artificial Intelligence (AI) playing a pivotal role. AI
            helps marketers understand consumer behavior, predict trends, automate
            tasks, and deliver personalized experiences like never before. With
            the ability to analyze massive datasets in real-time, AI is the key
            to smarter and more efficient marketing strategies.
          </p>
          <p style={styles.text}>
            <i className="fas fa-chart-line" style={styles.iconInline}></i>
            By leveraging AI technologies such as machine learning, natural
            language processing, and predictive analytics, businesses are
            improving their marketing effectiveness, increasing ROI, and building
            deeper connections with their audiences.
          </p>

          {/* Why AI in Digital Marketing Matters */}
          <h2 style={styles.subheading}>Why AI in Digital Marketing Matters</h2>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-user-friends" style={styles.iconList}></i>
              AI enhances customer segmentation, enabling targeted campaigns
            </li>
            <li>
              <i className="fas fa-clock" style={styles.iconList}></i>
              AI-driven automation saves time and reduces human error
            </li>
            <li>
              <i className="fas fa-chart-pie" style={styles.iconList}></i>
              Predictive analytics help marketers understand customer behavior
            </li>
            <li>
              <i className="fas fa-comments" style={styles.iconList}></i>
              Personalization is scaled to meet the individual needs of each
              customer
            </li>
          </ul>

          {/* Key AI-Driven Marketing Strategies */}
          <h2 style={styles.subheading}>Key AI-Driven Marketing Strategies</h2>
          <p style={styles.text}>
            To harness the full potential of AI, businesses should adopt the
            following strategies:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-palette" style={styles.iconList}></i>
              Personalized Recommendations through AI algorithms
            </li>
            <li>
              <i className="fas fa-comments" style={styles.iconList}></i>
              AI-powered chatbots for real-time customer service and engagement
            </li>
            <li>
              <i className="fas fa-search" style={styles.iconList}></i>
              Predictive analytics to forecast market trends and customer
              behavior
            </li>
            <li>
              <i className="fas fa-cogs" style={styles.iconList}></i>
              Automated content creation for social media posts and blogs
            </li>
          </ul>

          {/* Example: AI in Personalized Marketing */}
          <h2 style={styles.subheading}>Example: Personalized Marketing with AI</h2>
          <p style={styles.text}>
            <i className="fas fa-user-circle" style={styles.iconInline}></i>
            One of the biggest advantages of AI is its ability to personalize
            marketing campaigns at scale. Consider e-commerce websites, which use
            AI to analyze a customer's browsing history, past purchases, and
            preferences to recommend products tailored to their needs. This level
            of personalization increases customer satisfaction and loyalty, driving
            higher conversion rates and sales.
          </p>

          {/* AI and Customer Experience */}
          <h2 style={styles.subheading}>AI and Customer Experience</h2>
          <p style={styles.text}>
            <i className="fas fa-headset" style={styles.iconInline}></i>
            AI plays a crucial role in improving customer experience by offering
            seamless interactions across channels. Chatbots, powered by natural
            language processing, are now able to provide instant support, answer
            questions, and resolve issues 24/7. This allows businesses to provide
            a more responsive and interactive service experience to customers.
          </p>
          <p style={styles.text}>
            <i className="fas fa-rocket" style={styles.iconInline}></i>
            In addition, AI can be used to predict customer satisfaction levels,
            identify pain points in the customer journey, and recommend
            improvements, making it possible to enhance the overall experience
            constantly.
          </p>

          {/* Best Practices for AI in Digital Marketing */}
          <h2 style={styles.subheading}>Best Practices for AI in Digital Marketing</h2>
          <p style={styles.text}>
            <i className="fas fa-lightbulb" style={styles.iconInline}></i>
            To effectively implement AI in digital marketing, businesses should
            follow these best practices:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-users" style={styles.iconList}></i>
              Understand your audience: Use AI tools to gain deep insights into
              customer behavior and preferences.
            </li>
            <li>
              <i className="fas fa-calendar-check" style={styles.iconList}></i>
              Automate repetitive tasks: Let AI handle tasks such as email
              marketing, social media posts, and ad targeting.
            </li>
            <li>
              <i className="fas fa-comments" style={styles.iconList}></i>
              Integrate AI-powered chatbots for 24/7 customer support.
            </li>
            <li>
              <i className="fas fa-cogs" style={styles.iconList}></i>
              Focus on continuous optimization: Use AI to continually test and
              optimize campaigns based on data-driven insights.
            </li>
          </ul>

          {/* Future of AI in Digital Marketing */}
          <h2 style={styles.subheading}>The Future of AI in Digital Marketing</h2>
          <p style={styles.text}>
            <i className="fas fa-globe" style={styles.iconInline}></i>
            In the coming years, AI will become even more integrated into
            digital marketing strategies. Voice search, augmented reality (AR),
            and AI-powered video editing are just some of the trends to watch out
            for. By 2030, AI will likely drive the entire customer journey,
            offering hyper-personalized experiences and creating new ways to
            interact with brands.
          </p>

          {/* Conclusion */}
          <h2 style={styles.subheading}>Conclusion</h2>
          <p style={styles.text}>
            <i className="fas fa-check-circle" style={styles.iconInline}></i>
            AI is no longer a buzzword in digital marketing—it's an essential
            tool for creating smarter, more efficient campaigns. By integrating
            AI into your marketing strategies, you can boost engagement, improve
            customer satisfaction, and drive better business outcomes. As the
            digital landscape continues to evolve, those who embrace AI will be
            well-positioned to stay ahead of the competition.
          </p>
        </div>
      </div>

      {/* ===== Animation CSS ===== */}
      <style>
        {`
          @keyframes slideIn {
            0% {
              opacity: 0;
              transform: translateX(-40px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
          .slide-in {
            animation: slideIn 1.2s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
};

const styles = {
    page: {
    position: "relative",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
    letterSpacing: "0px",
  },
  /* ===== Banner Styles ===== */
  bannerSection: {
    position: "relative",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/aidigital.png')",  
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 10%",
    color: "#fff",
  },
  bannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  bannerContent: {
    position: "relative",
    zIndex: 2,
    maxWidth: "600px",
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    color: "white",
    letterSpacing:"0px",
  },
  bannerText: {
    fontSize: "18px",
    lineHeight: "1.6",
    maxWidth: "500px",
    textAlign: "justify",
  },

  /* ===== Blog Styles ===== */
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    maxWidth: "900px",
    margin: "auto",
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    color: "#0c859b",
    letterSpacing:"0px",
  },
  meta: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    gap: "12px",
  },
  authorImage: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  author: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "15px",
  },
  details: {
    margin: 0,
    fontSize: "14px",
    color: "#666",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#333",
    marginBottom: "15px",
    textAlign: "justify",
  },
  subheading: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "25px",
    marginBottom: "12px",
    letterSpacing:"0px",
  },
  list: {
    paddingLeft: "0px",
    marginBottom: "20px",
    listStyle: "none",
  },
  iconList: {
    marginRight: "8px",
    color: "#007bff",
  },
  iconInline: {
    marginRight: "6px",
    color: "#007bff",
  },

  /* ===== Responsive ===== */
  "@media (max-width: 768px)": {
    bannerTitle: {
      fontSize: "28px",
    },
    bannerText: {
      fontSize: "16px",
    },
    title: {
      fontSize: "26px",
    },
  },
};

export default BlogLayout;

   
